import { ReactNode } from 'react';

import IconCircleCross from 'approot/shared/icons/icon-circle-cross';
import { SecondaryButton } from 'approot/shared/styles/buttons/secondary-button.style';

type Props = {
  children: ReactNode;
  isSmall?: boolean;
  onClick: () => void;
};

/**
 * A button that dismisses a filter or selection, with an icon and label.
 * @param children - The children e.g. label of the button.
 * @param isSmall - Whether the button should be small.
 * @param onClick - The function to call when the button is clicked.
 * @returns A SecondaryButton that dismisses a filter or selection.
 */
const ButtonDismiss = ({ children, isSmall, onClick }: Props) => (
  <SecondaryButton
    type="button"
    $withIcon
    $borderRadius={40}
    $isSmall={isSmall}
    onClick={onClick}
  >
    {children}
    <IconCircleCross width={20} height={20} />
  </SecondaryButton>
);

export default ButtonDismiss;
